import styled from "styled-components";

export const CardEditOrdersLoader = styled.div`
  position: relative;
  padding: 4rem;
`;
